module.exports = __webpack_public_path__ + "img/reset-password.965156da.png";